import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { COMPANY_ANALYSIS_HOME, WEBSITE_ANALYSIS_PERFORMANCE } from "app/pages/sales-intelligence/constants/routes";
import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import CompanyBreadcrumbItem from "./CompanyBreadcrumbItem";
import DomainBreadcrumbItem from "./DomainBreadcrumbItem";
import { StyledHeaderLink } from "./styles";

const PageHeaderBreadcrumbs = ({ isDomainBreadcrumbVisible }: { isDomainBreadcrumbVisible?: boolean }) => {
    const handleCompanyClick = ({ key }: { key: string }) => {
        companyAnalysisTrackingService.trackBreadcrumbsCompanySelect();
        void proNavigator.updateParams({ key });
    };

    const handleWebsiteClick = (domain: string) => {
        companyAnalysisTrackingService.trackBreadcrumbsWebsiteSelect();
        void proNavigator.go(WEBSITE_ANALYSIS_PERFORMANCE, { key: domain, isWWW: "*", duration: "3m", country: 999 });
    };

    const handleChangeWebsite = (domain: string) => {
        companyAnalysisTrackingService.trackBreadcrumbsWebsiteSelect();
        void proNavigator.updateParams({ key: domain, isWWW: "*", duration: "3m", country: 999 });
    };

    const handleBackClick = () => {
        companyAnalysisTrackingService.trackBreadcrumbsBackClick();
    };

    const handleWebsiteSelectOpen = () => {
        companyAnalysisTrackingService.trackBreadcrumbsWebsiteClick();
    };
    const handleCompanySelectOpen = () => {
        companyAnalysisTrackingService.trackBreadcrumbsCompanyClick();
    };
    const handleCompanyBreadcrumbClick = () => {
        companyAnalysisTrackingService.trackBreadcrumbsCompanySelect();
    };

    return (
        <Flex
            alignItems="center"
            justifyContent="space-between"
            gap="8px"
            marginX="16px 0"
        >
            <Text fontVariant="chip1TopRow">
                <StyledHeaderLink
                    href={proNavigator.href(COMPANY_ANALYSIS_HOME)}
                    onMouseDown={handleBackClick}
                >
                    {translate("si.company-analysis.company.title")}
                </StyledHeaderLink>
            </Text>
            <SWReactIcons
                iconName="chev-right"
                size="xs"
                iconColor={colorsPalettes.carbon[300]}
            />
            <CompanyBreadcrumbItem
                onCompanyClick={handleCompanyClick}
                onWebsiteClick={handleWebsiteClick}
                isDomainBreadcrumbVisible={isDomainBreadcrumbVisible}
                onOpen={handleCompanySelectOpen}
                onCompanyBreadcrumbClick={handleCompanyBreadcrumbClick}
            />
            {isDomainBreadcrumbVisible ? (
                <DomainBreadcrumbItem
                    onWebsiteClick={handleChangeWebsite}
                    onOpen={handleWebsiteSelectOpen}
                />
            ) : null}
        </Flex>
    );
};

export default PageHeaderBreadcrumbs;
